(() => {

  const SELECTOR = '[data-cart-rewards]';

  let syncRunning = false;
  let syncScheduled = false;


  /* ========================================================
     HILFSFUNKTIONEN
     ======================================================== */

  function getRewardElement() {
    return document.querySelector(SELECTOR);
  }

  function getDismissedGiftKey(tier) {
    return `cart_reward_gift_${tier}_dismissed`;
  }

  function isGiftDismissed(tier) {
    return sessionStorage.getItem(
      getDismissedGiftKey(tier)
    ) === 'true';
  }

  function dismissGift(tier) {
    sessionStorage.setItem(
      getDismissedGiftKey(tier),
      'true'
    );
  }

  function resetDismissedGift(tier) {
    sessionStorage.removeItem(
      getDismissedGiftKey(tier)
    );
  }

  function getConfig() {

  const element = getRewardElement();

  if (!element) {
    console.warn(
      '[Cart Rewards] Reward-Element wurde nicht gefunden.'
    );

    return null;
  }


  const config = {
    element,

    gift30Enabled:
      element.getAttribute('data-gift-30-enabled') === 'true',

    shippingEnabled:
      element.getAttribute('data-shipping-enabled') === 'true',

    gift55Enabled:
      element.getAttribute('data-gift-55-enabled') === 'true',

    gift30Variant:
      Number(
        element.getAttribute('data-gift-30')
      ),

    gift55Variant:
      Number(
        element.getAttribute('data-gift-55')
      ),

    threshold30:
      Number(
        element.getAttribute('data-threshold-30') ||
        3000
      ),

    thresholdShipping:
      Number(
        element.getAttribute('data-threshold-shipping') ||
        4500
      ),

    threshold55:
      Number(
        element.getAttribute('data-threshold-55') ||
        5500
      )
  };


  console.log(
    '[Cart Rewards] Config:',
    {
      gift30Variant: config.gift30Variant,
      gift55Variant: config.gift55Variant,
      threshold30: config.threshold30,
      thresholdShipping: config.thresholdShipping,
      threshold55: config.threshold55
    }
  );


  return config;
}


  function isAutoGift(item) {

    if (!item.properties) {
      return false;
    }

    return (
      item.properties._auto_gift === 'true' ||
      item.properties._auto_gift === true
    );
  }


  function getQualifyingTotal(cart) {

    return cart.items.reduce((total, item) => {

      if (isAutoGift(item)) {
        return total;
      }

      return total + item.final_line_price;

    }, 0);
  }


  async function getCart() {

    const response = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          Accept: 'application/json',
          'X-Auto-Gift-Sync': '1'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    return response.json();
  }
  function getCartSections() {
  const cartDrawer =
    document.querySelector('cart-drawer');

  if (
    !cartDrawer ||
    typeof cartDrawer.getSectionsToRender !== 'function'
  ) {
    return [];
  }

  return cartDrawer
    .getSectionsToRender()
    .map(section => section.id);
}


function renderCartAfterReward(response) {
  const cartDrawer =
    document.querySelector('cart-drawer');

  if (
    !cartDrawer ||
    typeof cartDrawer.renderContents !== 'function' ||
    !response ||
    !response.sections
  ) {
    return;
  }

  cartDrawer.renderContents(response);

  window.requestAnimationFrame(async () => {
  const config = getConfig();

  if (!config) {
    return;
  }

  const cart = await getCart();

  updateVisualState(
    getQualifyingTotal(cart),
    config
  );
});

  console.log(
    '[Cart Rewards] Drawer nach Geschenk aktualisiert'
  );
}

  /* ========================================================
     GESCHENK SUCHEN
     ======================================================== */

  function findGift(cart, variantId) {

    return cart.items.find(item => {

      return (
        Number(item.variant_id) === Number(variantId) &&
        isAutoGift(item)
      );

    });
  }


  /* ========================================================
     GESCHENK HINZUFÜGEN
     ======================================================== */

  async function addGift(variantId, tier) {

    if (!variantId) {
        console.warn(
        `Gift variant für ${tier} € wurde nicht gefunden.`
        );

        return null;
    }

    const sections =
        getCartSections();

    const payload = {
        items: [
        {
            id: variantId,
            quantity: 1,

            properties: {
            _auto_gift: 'true',
            _gift_tier: String(tier)
            }
        }
        ]
    };


    if (sections.length) {
        payload.sections = sections;
        payload.sections_url =
        window.location.pathname;
    }


    const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
        method: 'POST',

        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Auto-Gift-Sync': '1'
        },

        body: JSON.stringify(payload)
        }
    );


    const data =
        await response.json();


    if (!response.ok) {

        console.error(
        `Gratisgeschenk ${tier} € konnte nicht hinzugefügt werden:`,
        data
        );

        return null;
    }


    console.log(
        `Gratisgeschenk ${tier} € hinzugefügt.`
    );


    return data;
    }
  async function removeGift(lineKey) {

    if (!lineKey) {
        return null;
    }


    const sections =
        getCartSections();


    const payload = {
        id: lineKey,
        quantity: 0
    };


    if (sections.length) {
        payload.sections = sections;
        payload.sections_url =
        window.location.pathname;
    }


    const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
        method: 'POST',

        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Auto-Gift-Sync': '1'
        },

        body: JSON.stringify(payload)
        }
    );


    const data =
        await response.json();


    if (!response.ok) {

        console.error(
        'Gratisgeschenk konnte nicht entfernt werden:',
        data
        );

        return null;
    }


    return data;
    }

function getActiveRewards(config) {

  const rewards = [];

  if (config.gift30Enabled) {
    rewards.push({
      type: 'gift30',
      threshold: config.threshold30
    });
  }

  if (config.shippingEnabled) {
    rewards.push({
      type: 'shipping',
      threshold: config.thresholdShipping
    });
  }

  if (config.gift55Enabled) {
    rewards.push({
      type: 'gift55',
      threshold: config.threshold55
    });
  }

  return rewards.sort(
    (a, b) => a.threshold - b.threshold
  );
}


function calculateProgress(total, config) {

  const rewards = getActiveRewards(config);

  if (!rewards.length) {
    return 0;
  }

  /*
   * Vor dem ersten Reward noch keine Linie.
   */
  if (total < rewards[0].threshold) {
    return 0;
  }

  /*
   * Nur ein aktiver Reward.
   */
  if (rewards.length === 1) {
    return 100;
  }

  /*
   * Positionen gleichmäßig auf der Progressbar verteilen:
   *
   * 2 Rewards: 0 % / 100 %
   * 3 Rewards: 0 % / 50 % / 100 %
   */
  for (let i = 0; i < rewards.length - 1; i++) {

    const currentReward = rewards[i];
    const nextReward = rewards[i + 1];

    if (
      total >= currentReward.threshold &&
      total < nextReward.threshold
    ) {

      const segmentSize =
        100 / (rewards.length - 1);

      const segmentStart =
        i * segmentSize;

      const range =
        nextReward.threshold -
        currentReward.threshold;

      const progressWithinSegment =
        range > 0
          ? (total - currentReward.threshold) / range
          : 1;

      return (
        segmentStart +
        progressWithinSegment * segmentSize
      );
    }
  }

  return 100;
}
  /* ========================================================
     VISUELLE ANZEIGE AKTUALISIEREN
     ======================================================== */

  function updateVisualState(
    total,
    config
  ) {

    const element = getRewardElement();

    if (!element) {
      return;
    }


    const progress =
      calculateProgress(
        total,
        config
      );


    const trackElement =
  element.querySelector(
    '.cart-rewards__track'
  );

if (trackElement) {
  trackElement.style.setProperty(
    '--reward-progress',
    `${Math.min(progress, 100)}%`
  );
}


    element
      .querySelectorAll(
        '[data-reward-milestone]'
      )
      .forEach(milestone => {

        const tier =
          Number(
            milestone.dataset.rewardMilestone
          );

        let reached = false;


        if (tier === 30) {

          reached =
            total >= config.threshold30;

        }


        if (tier === 45) {

          reached =
            total >=
            config.thresholdShipping;

        }


        if (tier === 55) {

          reached =
            total >= config.threshold55;

        }


        milestone.classList.toggle(
          'is-reached',
          reached
        );

      });


    updateStatusMessage(
      element,
      total,
      config
    );
  }


  /* ========================================================
     STATUS TEXT
     ======================================================== */

  function formatMoney(cents) {

    return new Intl.NumberFormat(
      'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    ).format(
      cents / 100
    );
  }


function updateStatusMessage(
  element,
  total,
  config
) {

  const status =
    element.querySelector(
      '[data-rewards-status]'
    );

  const footer =
    element.querySelector(
      '[data-rewards-footer]'
    );

  if (!status) {
    return;
  }


  const rewards =
    getActiveRewards(config);

  const nextReward =
    rewards.find(
      reward => total < reward.threshold
    );


  /*
   * Alle aktiven Rewards erreicht.
   */
  if (!nextReward) {

    status.textContent =
      '🎉 Alle Vorteile freigeschaltet!';

    if (footer) {
      footer.textContent =
        '✓ Du hast alle Vorteile erreicht.';
    }

    return;
  }


  const remaining =
    nextReward.threshold - total;


  if (nextReward.type === 'shipping') {

    status.textContent =
      `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand`;

  } else {

    status.textContent =
      `Noch ${formatMoney(remaining)} bis zu deinem Gratisgeschenk`;

  }


  /*
   * Footer
   */
  const reachedRewards =
    rewards.filter(
      reward => total >= reward.threshold
    );


  if (!footer) {
    return;
  }


  if (!reachedRewards.length) {

    footer.textContent =
      'Fülle Deinen Warenkorb und sichere Dir Deine Vorteile.';

    return;
  }


  const lastReached =
    reachedRewards[
      reachedRewards.length - 1
    ];


  if (lastReached.type === 'shipping') {

    footer.textContent =
      '✓ Kostenloser Versand freigeschaltet';

  } else {

    footer.textContent =
      '✓ Gratisgeschenk freigeschaltet';

  }
}


  /* ========================================================
     HAUPTLOGIK
     ======================================================== */

  async function syncRewards() {

    if (syncRunning) {
      return;
    }

    const config = getConfig();

    if (!config) {
      return;
    }


    syncRunning = true;

    let cartChanged = false;
    let lastCartResponse = null;    


    try {

      let cart = await getCart();

      const qualifyingTotal =
        getQualifyingTotal(cart);


      updateVisualState(
        qualifyingTotal,
        config
      );

      /*
      * Wenn eine Reward-Schwelle wieder unterschritten wurde,
      * darf das Geschenk beim nächsten Erreichen erneut
      * automatisch hinzugefügt werden.
      */
      if (qualifyingTotal < config.threshold30) {
        resetDismissedGift(30);
      }

      if (qualifyingTotal < config.threshold55) {
        resetDismissedGift(55);
      }

    /* ---------------------------------------------
      30-€-GESCHENK
      --------------------------------------------- */

    let gift30 =
      findGift(
        cart,
        config.gift30Variant
      );


    /*
    * Geschenk soll vorhanden sein,
    * wenn:
    *
    * 1. der Reward im Theme Editor aktiviert ist
    * 2. der Warenkorbwert mindestens 30 € beträgt
    */

    const gift30ShouldExist =
      config.gift30Enabled &&
      qualifyingTotal >= config.threshold30 &&
      !isGiftDismissed(30);


    if (gift30ShouldExist) {

      if (!gift30) {

        const response30 =
          await addGift(
            config.gift30Variant,
            30
          );

        if (response30) {

          lastCartResponse =
            response30;

          cartChanged = true;

          cart =
            await getCart();

        }

      }

    } else {

      /*
      * Wichtig:
      *
      * Auch wenn der Kunde bereits über 30 € liegt,
      * wird das Geschenk entfernt, sobald der
      * Theme-Editor-Haken ausgeschaltet ist.
      */

      if (gift30) {

        const response30 =
          await removeGift(
            gift30.key
          );

        if (response30) {

          lastCartResponse =
            response30;

          cartChanged = true;

          cart =
            await getCart();

        }

      }

    }

      /* ---------------------------------------------
         55-€-GESCHENK
         --------------------------------------------- */

      let gift55 =
        findGift(
          cart,
          config.gift55Variant
        );


      const gift55ShouldExist =
        config.gift55Enabled &&
        qualifyingTotal >= config.threshold55 &&
        !isGiftDismissed(55);

      if (gift55ShouldExist) {

        if (!gift55) {

          const response55 =
            await addGift(
              config.gift55Variant,
              55
            );

          if (response55) {

            lastCartResponse =
              response55;

            cartChanged = true;

            cart =
              await getCart();

          }

        }

      } else {

        if (gift55) {

          const response55 =
            await removeGift(
              gift55.key
            );

          if (response55) {

            lastCartResponse =
              response55;

            cartChanged = true;

            cart =
              await getCart();

          }

        }

      }


      /* ---------------------------------------------
         DRAWER NACH REWARD-ÄNDERUNG AKTUALISIEREN
         --------------------------------------------- */

      if (
        cartChanged &&
        lastCartResponse
      ) {

        renderCartAfterReward(
          lastCartResponse
        );

      }

    } catch (error) {

      console.error(
        'Fehler bei Cart Rewards:',
        error
      );

    } finally {

      syncRunning = false;

    }
  }


  /* ========================================================
     TOOLTIP KLICK AUF MOBILE
     ======================================================== */

  document.addEventListener(
    'click',
    event => {

      const milestone =
        event.target.closest(
          '[data-reward-milestone]'
        );


      if (!milestone) {

        document
          .querySelectorAll(
            '.cart-rewards__milestone.is-open'
          )
          .forEach(item => {

            item.classList.remove(
              'is-open'
            );

          });

        return;

      }


      const currentlyOpen =
        milestone.classList.contains(
          'is-open'
        );


      document
        .querySelectorAll(
          '.cart-rewards__milestone.is-open'
        )
        .forEach(item => {

          item.classList.remove(
            'is-open'
          );

        });


      if (!currentlyOpen) {

        milestone.classList.add(
          'is-open'
        );

      }

    }
  );


  /* ========================================================
     ÄNDERUNGEN AM SHOPIFY CART ERKENNEN

     Wir beobachten cart/add.js,
     cart/change.js,
     cart/update.js usw.
     ======================================================== */

  const originalFetch =
    window.fetch.bind(window);


  window.fetch = async function(
    resource,
    options = {}
  ) {

    /*
    * Vor dem Request merken wir uns den Warenkorb,
    * wenn ein normaler Kunden-Request den Cart verändert.
    */
    let cartBeforeRequest = null;

    let url = '';

    try {
      url =
        typeof resource === 'string'
          ? resource
          : resource.url;
    } catch (error) {
      url = '';
    }


    const headers =
      options.headers || {};

    let isOwnRequest = false;


    if (headers instanceof Headers) {

      isOwnRequest =
        headers.get(
          'X-Auto-Gift-Sync'
        ) === '1';

    } else {

      isOwnRequest =
        headers[
          'X-Auto-Gift-Sync'
        ] === '1';

    }


    const cartRequest =
      /\/cart\/(add|change|update|clear)(\.js)?/i.test(
        url
      );


    /*
    * Nur bei echten Kundenaktionen benötigen wir
    * den Warenkorbzustand vor der Änderung.
    */
    if (
      cartRequest &&
      !isOwnRequest
    ) {

      try {
        cartBeforeRequest =
          await getCart();
      } catch (error) {
        cartBeforeRequest = null;
      }

    }


    /*
    * Ursprünglichen Shopify-Request ausführen.
    */
    const response =
      await originalFetch(
        resource,
        options
      );


    try {

      if (
        cartRequest &&
        !isOwnRequest
      ) {

        /*
        * Warenkorb nach der Kundenaktion laden.
        */
        const cartAfterRequest =
          await getCart();


        if (cartBeforeRequest) {

          const config =
            getConfig();


          if (config) {

            /*
            * Prüfen, ob Geschenk 30 vor der Aktion
            * vorhanden war und danach fehlt.
            */
            const gift30Before =
              findGift(
                cartBeforeRequest,
                config.gift30Variant
              );

            const gift30After =
              findGift(
                cartAfterRequest,
                config.gift30Variant
              );


            if (
              gift30Before &&
              !gift30After
            ) {

              dismissGift(30);

              console.log(
                '[Cart Rewards] Geschenk 30 manuell entfernt.'
              );

            }


            /*
            * Dasselbe für Geschenk 55.
            */
            const gift55Before =
              findGift(
                cartBeforeRequest,
                config.gift55Variant
              );

            const gift55After =
              findGift(
                cartAfterRequest,
                config.gift55Variant
              );


            if (
              gift55Before &&
              !gift55After
            ) {

              dismissGift(55);

              console.log(
                '[Cart Rewards] Geschenk 55 manuell entfernt.'
              );

            }

          }

        }


        scheduleSync();

      }

    } catch (error) {

      console.warn(
        '[Cart Rewards] Kundenänderung konnte nicht vollständig geprüft werden.',
        error
      );

      scheduleSync();

    }


    return response;
  };


  /* ========================================================
     SYNC VERZÖGERT AUSFÜHREN
     ======================================================== */

  function scheduleSync() {

    if (syncScheduled) {
      return;
    }


    syncScheduled = true;


    window.setTimeout(
      async () => {

        syncScheduled = false;

        await syncRewards();

      },
      350
    );

  }


  /* ========================================================
     INITIALISIERUNG
     ======================================================== */

  function init() {

    scheduleSync();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  window.addEventListener(
    'pageshow',
    scheduleSync
  );

})();
